/**
 * @file     signaturePaths.ts
 * @purpose  The public Relta Signature pages: a signer's link and the
 *           verifier. They carry their own brand bar, show no listings, and are
 *           opened by people without an account, so site-wide chrome, prompts,
 *           the browse-wrap notice and default-on analytics stay off them.
 */
export const SIGNATURE_PATH_PATTERN = /^\/(sign\/|verify(\/|$))/;

export function isSignaturePublicPath(pathname: string | null | undefined): boolean {
  return Boolean(pathname && SIGNATURE_PATH_PATTERN.test(pathname));
}
